import React, { useState } from "react";
import TickIcon from "images/icons/tick-dark.inline.svg";
import InfoIcon from "images/icons/info-outline.inline.svg";

const filterItems = (items, hasProductType) =>
  items?.map((item) => {
    return {
      ...item,
      coreIncludes: item?.coreIncludes?.filter((productType) =>
        productType?.coreIncludesProductType?.some(({ slug }) =>
          hasProductType?.includes(slug.toLowerCase())
        )
      )
    };
  });
const TableRowComponent = ({
  keyId,
  itemDescription,
  item,
  productType,
  hasProductType,
  tooltipOpen,
  setTooltipOpen
}) => {
  const shouldRender = productType?.some(({ slug }) =>
    hasProductType?.includes(slug.toLowerCase())
  );

  return shouldRender ? (
    <tr
      key={`${keyId}-id`}
      className="whats-included-list-item text-black-lighter dark:text-gray-generic !border-0"
    >
      <td className="pt-4 border-0">
        {item}
        {itemDescription && (
          <div
            className={`tooltip tooltip-top ${item?.length > 20 ? "md:tooltip-left" : "md:tooltip-right"} w-1/6 md:w-5 top-[7px] before:py-3 before:rounded-xxs before:bg-yellow-standard before:dark:bg-gray-standard before:text-white before:dark:text-white tooltip-${tooltipOpen}`}
            data-tip={itemDescription}
          >
            <InfoIcon
              onClick={() => setTooltipOpen(1 - tooltipOpen)}
              className="fill-black-lighter dark:fill-white stroke-transparent group-hover:sm:fill-white ml-2 z-10"
            />
          </div>
        )}
      </td>
      <td className="pt-4 pr-5 border-0">
        <TickIcon className="w-3 h-3 stroke-black-lighter dark:stroke-white float-right" />
      </td>
    </tr>
  ) : null;
};

const WhatsIncludedContent = ({
  whatsIncluded,
  groupsWhatsIncluded,
  hasProductType
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(0);

  const whatsIncludedList = filterItems(whatsIncluded, hasProductType);

  return (
    <>
      <div className="flex flex-col justify-center h-full pt-2 md:pt-0 pb-8 md:pb-10 bg-transparent">
        <div className="w-full rounded-sm mx-autoshadow-lg">
          <div className="overflow-x-auto">
            {groupsWhatsIncluded.length > 1 && (
              <table
                className="w-full table-auto"
                key={"groups-whats-included"}
              >
                <thead className="text-[15px] sm:text-base font-semibold text-black-lighter dark:text-white border-b-[1px] border-light dark:border-b-gray-light">
                  <tr>
                    <th className="w-4/5 py-4 whitespace-nowrap">
                      <div className="font-semibold text-left">General</div>
                    </th>
                    {groupsWhatsIncluded.length > 1 ? (
                      <>
                        <th className="py-4 whitespace-nowrap w-[10%]">
                          <div className="font-semibold text-right">Groups</div>
                        </th>
                      </>
                    ) : (
                      <>
                        <th className="py-4 whitespace-nowrap w-[10%]"></th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody className="text-[15px] sm:text-base divide-y text-black-lighter dark:text-white">
                  {groupsWhatsIncluded.length > 1 ? (
                    groupsWhatsIncluded.map(({ generalItem }) => (
                      <tr
                        key={`${generalItem}-id`}
                        className="text-black-lighter dark:text-white !border-0"
                      >
                        <td className="pt-4 border-0">{generalItem}</td>
                        <td className="pt-4 pr-5 border-0">
                          <TickIcon className="w-3 h-3 stroke-black-lighter dark:stroke-white float-right" />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            )}
          </div>

          {whatsIncludedList?.length > 1 &&
            whatsIncludedList.map(
              ({ coreIncludes, coreIncludesHeading }, idx) =>
                coreIncludes?.length > 0 && (
                  <div className="overflow-x-auto" key={`core-includes-${idx}`}>
                    <table
                      className="w-full table-auto"
                      key={`core-includes-table-${idx}`}
                    >
                      <thead className="text-[15px] sm:text-base font-semibold  text-black-lighter dark:text-white border-b-[1px] border-light dark:border-b-gray-light">
                        <tr>
                          <th className="w-4/5 py-4  whitespace-nowrap">
                            <div className="font-semibold text-left">
                              {coreIncludesHeading}
                            </div>
                          </th>
                          <th className="py-4 whitespace-nowrap w-[10%]"></th>
                        </tr>
                      </thead>
                      <tbody className="text-[15px] sm:text-base divide-y text-black-lighter dark:text-gray-generic">
                        {coreIncludes.map(
                          ({
                            coreIncludesItem,
                            coreIncludesDescr,
                            coreIncludesProductType
                          }) => (
                            <TableRowComponent
                              key={coreIncludesItem}
                              keyId={coreIncludesItem}
                              item={coreIncludesItem}
                              itemDescription={coreIncludesDescr}
                              productType={coreIncludesProductType}
                              hasProductType={hasProductType}
                              tooltipOpen={tooltipOpen}
                              setTooltipOpen={setTooltipOpen}
                            />
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                )
            )}
        </div>
      </div>
    </>
  );
};

export default WhatsIncludedContent;
